import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SlUnselectedCheckbox",
  "use": "SlUnselectedCheckbox-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"SlUnselectedCheckbox\"><path d=\"M2.375 4c0-.897.728-1.625 1.625-1.625h8c.898 0 1.625.728 1.625 1.625v8c0 .898-.727 1.625-1.625 1.625H4A1.625 1.625 0 0 1 2.375 12V4z\" stroke=\"#BEC7D3\" stroke-width=\".75\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol